import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

interface BasePathProviderProps {
  basePath: string;
  children: ReactNode;
}

const BasePathContext = createContext<string>("/");

export const useBasePath = () => useContext(BasePathContext);

export const BasePathProvider = ({
  basePath,
  children,
}: BasePathProviderProps) => {
  return (
    <BasePathContext.Provider value={basePath}>
      {children}
    </BasePathContext.Provider>
  );
};
